// Small formatting helpers shared by the homepage restaurant & attraction
// sections so they can render the raw data files without extra copy.

const EMOJI = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu;

export const stripEmoji = (text: string): string => text.replace(EMOJI, '').replace(/\s{2,}/g, ' ').trim();

export const streetLine = (address: string): string => address.split(',')[0].trim();

export const neighborhoodLine = (address: string): string => {
  const parts = address.split(',').map((p) => p.trim());
  return parts.length > 1 ? parts[1] : '';
};

export const websiteHost = (url: string): string => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return 'Website';
  }
};

// No origin: Google Maps starts from the guest's current location, so the
// house address never appears in links on the public site.
export const directionsUrl = (name: string, address: string): string =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${name}, ${address}`)}`;
